module.exports = __webpack_public_path__ + "img/raven-bow.5a4a1635.webp";